module.exports = __webpack_public_path__ + "media/img/home/product_border-cda47cd1855924669e0bedcda3e347f0.svg";